import { SuperAdminAuthUserPayload } from "./super_admin_auth_storage";

export const IMPERSONATION_CONTEXT_STORAGE_KEY = "impersonationContext";

export interface ImpersonationContext {
  tenantName: string;
  impersonatedUserId: number;
  superAdminAuthBackup: SuperAdminAuthUserPayload;
  /** ISO-8601 UTC — fim da sessão JWT de impersonation */
  expiresAt?: string;
}

export const getImpersonationContext = (): ImpersonationContext | null => {
  const raw = sessionStorage.getItem(IMPERSONATION_CONTEXT_STORAGE_KEY);

  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as ImpersonationContext;
  } catch {
    return null;
  }
};

export const setImpersonationContext = (context: ImpersonationContext): void => {
  sessionStorage.setItem(
    IMPERSONATION_CONTEXT_STORAGE_KEY,
    JSON.stringify(context)
  );
};

export const clearImpersonationContext = (): void => {
  sessionStorage.removeItem(IMPERSONATION_CONTEXT_STORAGE_KEY);
};

export const isImpersonationContextActive = (): boolean =>
  getImpersonationContext() !== null;
